import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as S from "./styles";

import useWindowSize from "../../hooks/useWindowSize";

import { api } from "../../services/api";

const Banner = ({ data }) => {
  const [linkUrl, setLinkUrl] = useState();
  const [linkLabel, setLinkLabel] = useState();

  const windowSize = useWindowSize();

  useEffect(() => {
    if (!data.name) return;

    if (data.link_label) {
      setLinkLabel(data.link_label);
    } else {
      setLinkLabel("Ver Guarita");
    }

    if (data.product_id) {
      setLinkUrl(`/produtos/${data.product_id}`);
    } else if (data.link_url) {
      setLinkUrl(data.link_url);
    }
  }, [data]);

  const isPhotoOnly = !data.text || data.text.trim() === "";

  return (
    data && (
      <S.BannerWrapper className={isPhotoOnly ? "photo-only" : undefined}>
        {!isPhotoOnly && (
          <div className="text-container">
            <h1>{data.name}</h1>
            <p>{data.text}</p>
            {linkUrl && (
              <Link to={linkUrl} className="btn">
                {linkLabel}
              </Link>
            )}
          </div>
        )}

        {data.all_images && data.all_images.length > 0 ? (
          <div className="gallery-wrapper">
            {data.all_images.map((path, idx) => (
              <div className="image-container" key={idx}>
                <img src={`${api.getUri()}/storage/${path}`} alt="" />
              </div>
            ))}
          </div>
        ) : data.image_path && (
          <div className="image-container">
            <img src={`${api.getUri()}/storage/${data.image_path}`} alt={data.name || ""} />
          </div>
        )}
      </S.BannerWrapper>
    )
  );
};

export default Banner;
